Shopify.queryParams = {};
if (location.search.length) { for(var aKeyValue,i=0,aCouples=location.search.substr(1).split('&');i<aCouples.length;i++){aKeyValue=aCouples[i].split('=');if(aKeyValue.length>1){Shopify.queryParams[decodeURIComponent(aKeyValue[0])]=decodeURIComponent(aKeyValue[1])}} };
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a}
function queryParams(a){var b=[];for(var c in a)b.push(encodeURIComponent(c)+"="+encodeURIComponent(a[c]));return b.join("&")}    
if (!Shopify.formatMoney) {
  Shopify.formatMoney=function(a,e){var t="",r=/\{\{\s*(\w+)\s*\}\}/,o=e||this.money_format;function n(a,e){return void 0===a?e:a}function c(a,e,t,r){if(e=n(e,2),t=n(t,","),r=n(r,"."),isNaN(a)||null==a)return 0;var o=(a=(a/100).toFixed(e)).split(".");return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+t)+(o[1]?r+o[1]:"")}switch("string"==typeof a&&(a=a.replace(".","")),o.match(r)[1]){case"amount":t=c(a,2);break;case"amount_no_decimals":t=c(a,0);break;case"amount_with_comma_separator":t=c(a,2,".",",");break;case"amount_no_decimals_with_comma_separator":t=c(a,0,".",",")}return o.replace(r,t)};
}
class SiteHeader extends HTMLDivElement {
  constructor(){
    super(),
      this.sehead = this.querySelector(".site__header"),
      this.siteCont = this.querySelector(".search-content"),
      this.seMenu = this.querySelector(".settings-menu"),
      this.semmenu = this.querySelector(".main_menu"),     
      this.cartdrawer = this.querySelector(".cart__drawer"),
      this.hasChild = this.querySelector(".childarrow"),
      this.querySelector(".site_search").addEventListener("click", this.onSearchOpen.bind(this)),
      this.querySelector(".search_close").addEventListener("click", this.onSearchClose.bind(this)),
      this.querySelector(".settings").addEventListener("click", this.onSettings.bind(this)),
      this.querySelector(".menu_wrapper").addEventListener("click", this.onMobMenu.bind(this)),
      this.querySelector(".hasChild").addEventListener("mouseenter", this.onMenuHoverLeave.bind(this)),
      this.querySelector(".hasChild").addEventListener("mouseleave", this.onMenuHoverLeave.bind(this)),
      this.querySelector(".hasChild").addEventListener("click", this.onMenuClick.bind(this)),
      this.querySelector(".site_carter").addEventListener("click", this.onCartMenu.bind(this)),
      //this.querySelector(".cartNote").addEventListener("click", this.onCartNote.bind(this)),      
      this.querySelectorAll('.crdswitch').forEach((summary) => {
        summary.addEventListener("click", this.onCartCurrency.bind(this));
      })      
   // document.addEventListener('scroll', this.onHeadScroll.bind(this));
    document.addEventListener('scroll', this.debounce((event) => {
      this.onHeadScroll(event);
    }, 50).bind(this));
  }
  onHeadScroll(event){
      if((document.body.clientWidth>600)&&(window.scrollY > 200)&&(this.sehead.classList.contains('sticky_header')==0)){
        this.sehead.classList.add('sticky_header')  
      } else if((window.scrollY < 300) && (this.sehead.classList.contains('sticky_header')==1)){
        this.sehead.classList.remove('sticky_header')
      }           
  }
  onCartCurrency(event) {
    event.preventDefault()
//    let formData = { 'note': 'This is a note about my order'};
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({'currency':event.currentTarget.getAttribute("data_iso")})
    }).then(response => { return response.json(); }).catch((error) => {
      //console.error('Error:', error);
    }).then(data => {
      window.location.reload(1);
    });
  }
  onCartMenu(event) {
    event.preventDefault()
    if(event.target.classList.contains("carterActive")==true){
      event.target.classList.remove("carterActive"),this.cartdrawer.style.display="none"; 
      return;
    }
    event.target.classList.add("carterActive"),this.cartdrawer.style.display="block";
  }
  onMenuHoverLeave(event) {
    if(event.target.classList.contains("active")==true){
      event.target.classList.remove("active"),event.target.querySelector('.child').style.display="none";
      return;
    }
    event.target.classList.add("active"),event.target.querySelector('.child').style.display="block";
  }
  onMenuClick(event) {
    console.log(event.target.parentNode);
    if(event.target.classList.contains("active")==true){
      event.target.classList.remove("active"),this.hasChild.classList.add("icon-arrow-down"),this.hasChild.classList.remove("icon-arrow-up"),document.querySelector('.child').style.display="none";
      return;
    }
    this.hasChild.classList.add("icon-arrow-up"),this.hasChild.classList.remove("icon-arrow-down"),event.target.classList.add("active"),document.querySelector('.child').style.display="block";
  }
  //   onMenuHover(event){
//     event.target.classList.add("active"),event.target.querySelector('.child').style.display="block";
//   }
//   onMenuLeave(event){
//     event.target.classList.remove("active"),event.target.querySelector('.child').style.display="none";
//   }
  onMobMenu(event) {
    event.preventDefault()
    if(this.sehead.classList.contains("toogleActive")==true){
      this.sehead.classList.remove("toogleActive"),this.semmenu.style.display="none"; 
      return;
    }
    this.sehead.classList.add("toogleActive"),this.semmenu.style.display="block";
  }
  onSettings(event) {
    //event.preventDefault()
    if(event.target.classList.contains("setActive")==true){
      event.target.classList.remove("setActive"),this.seMenu.style.display="none"; 
      return;
    }
    event.target.classList.add("setActive"),this.seMenu.style.display="block";
  }
  onSearchOpen(event) {
    event.preventDefault()
    if(event.target.classList.contains("setActive")==true){
      event.target.classList.remove("setActive"),this.siteCont.style.display="none";
      return;
    }
    event.target.classList.add("setActive"),this.siteCont.style.display="block";      
  }
  onSearchClose(event) {
    event.preventDefault(),this.siteCont.style.display="none",this.siteCont.classList.remove("setActive");  
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }  
}
 customElements.define("s-head",SiteHeader,{extends:"div"});

class CartTemp extends HTMLDivElement {
  constructor() {
    super();
    this.querySelectorAll('.input_qty').forEach((summary) => {
      summary.addEventListener("change", this.onCartUpdate.bind(this));
    });        
    var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => { return data });
	console.log(cartContents);
  }
  onQtyAdd(event){
   // console.log(event.target.value);
   // console.log(event.target.getAttribute("data_id"));
    let formData = {
      'items': [{
        'id': event.target.getAttribute("data_id"),
        'quantity': event.target.value
      }]
    };

    var content = fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
    
    console.log(content);

  }
  onCartUpdate(event){
    //   console.log(item);
    //     let formData = {
    //       'items': [{
    //         'id': event.target.getAttribute("data_id"),
    //         'quantity': event.target.value
    //       }]
    //     };
    //data_key
//    const body = JSON.stringify({"id":event.target.getAttribute("data_id"),"quantity":event.target.value});
//     const body = JSON.stringify({"id":event.target.getAttribute("data_key"),"quantity":parseInt(event.target.value)});

//     console.log(body);
//     //     const body = JSON.stringify({"id":"40395815616556","quantity":"2"});
//     var content = fetch(window.Shopify.routes.root + 'cart/change.js', {
//       method: 'POST',
//       credentials: 'same-origin',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: body,
//     }).then(response => {  
//       return response.json();
//     })
//     .catch((error) => {
//       console.error('Error:', error);
//     });
//     console.log(content);     
    
    
  }

}
 customElements.define("cart-temp",CartTemp,{extends:"div"});
class CollectionTemp extends HTMLDivElement {
  constructor() {
    super();
      this.cartTotal = document.querySelector('.cartTotal');
    this.cartCount = document.querySelector('.txt_number');
      this.description = this.querySelectorAll(".product-list-des"),  
      this.onCole = this.onColl(),
      this.listview = this.querySelector(".list_view"),
      this.querySelector("#SortBy").addEventListener("change", this.onSortBy.bind(this)),      
      this.mobsidebar = this.querySelector(".moc_nav"),
      this.listview.addEventListener("click", this.onListView.bind(this)),      
      this.querySelectorAll('.buy_cart').forEach((summary) => {
        summary.addEventListener("click", this.onCartAdd.bind(this));
      }), 
      this.querySelectorAll('.buy_view').forEach((summary) => {
        summary.addEventListener("click", this.onProductView.bind(this));
      }),        
      this.cartNotifier = this.querySelector(".cart_notifier"),
      this.cartRemindTxt = this.querySelector("#remin_text");    
     // document.body.addEventListener("click", this.onCallFilterClose.bind(this)); 

//     document.body.addEventListener('click', this.debounce((event) => {
//       this.onCallFilterClose(event);
//     }, 50).bind(this));

    this.querySelector(".col_filter").addEventListener('click', this.debounce((event) => {
      this.onCallFilter(event);
    }, 150).bind(this));
    this.querySelector(".mobfilterclose").addEventListener('click', this.debounce((event) => {
      this.onCallFilterClose(event);
    }, 150).bind(this));

 //     this.querySelector(".col_filter").addEventListener("click", this.onCallFilter.bind(this)), 
    
    
    this.mobfiwrp = this.querySelector("#moc_nav");    

  }
  onCallFilter(event){
//     if(this.mobsidebar.classList.contains("mynav")==true){
//       this.mobsidebar.classList.remove("mynav"); 
//       return;
//     }
    this.mobsidebar.classList.add("mynav");
  }  
  onCallFilterClose(event){
    if(this.mobsidebar.classList.contains("mynav")==true){
      this.mobsidebar.classList.remove("mynav"); 
      return;
    }    
//     if((document.body.classList.contains("devmobmynav"))&&(document.getElementById('moc_nav').classList.contains("mynav"))&&(!document.getElementById('moc_nav').contains(event.target))){
//       console.log("hi");
//       this.mobfiwrp.classList.remove("mynav"),
//       this.mobfiwrp.style.display = "none";
//       document.body.style.overflow = "";
//       //$(".nav_over").removeClass("modal-overlay-side"),
//       //$("body").css("overflow","");
//     } 
  }
  onSortBy(event){
    Shopify.queryParams.sort_by = event.target.value,location.search = queryParams(Shopify.queryParams);
  }
  onProductView(event){
    //console.log(event.currentTarget.getAttribute("purl"));
    window.location.href = event.currentTarget.getAttribute("purl");
  }
  onCartCount(){
    var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => { 
     this.cartTotal.innerHTML = Shopify.formatMoney(data.total_price, Shopify.moneFomart);
		//return data 
         this.cartCount.innerHTML = data.item_count;         
     }); 
  }
  onCartAdd(event){
    event.preventDefault();
    let formData = {
      'items': [{
        'id': event.currentTarget.getAttribute("data_id"),
        'quantity': 1
      }]
    };
	var vid = event.currentTarget.getAttribute("data_id");
    var content = fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .catch((error) => {
      //console.error('Error:', error);
    }).then(data => {
      if(data.items){
        this.cartNotifier.style.display = "block",this.cartRemindTxt.innerHTML = data.items[0].product_title,this.cartNotifier.scrollIntoView();
      	this.onCartCount();
      }
      else if(data.message == "Cart Error"){
        this.cartNotifier.style.display = "block",this.cartRemindTxt.innerHTML = data.description,this.cartNotifier.scrollIntoView();
      }
    });
  }
  onListView(event){
    if(this.listview.getAttribute("data")=="list"){
      window.location.href = location.protocol + '//' + location.host + location.pathname+"?view=list";
    }
    if(this.listview.getAttribute("data")=="grid"){
      window.location.href = location.protocol + '//' + location.host + location.pathname;        
    }
  }
  onColl(){
    if((this.querySelector(".ragMin"))||(this.querySelector(".ragMax"))){
      this.rangeMin = this.querySelector(".ragMin");
      this.rangeMin.addEventListener("change", this.onRangeMin.bind(this));
      this.rangeMax = this.querySelector(".ragMax");
      this.rangeMax.addEventListener("change", this.onRangeMax.bind(this));
    }       
  }
  onRangeMin(event){
    if(parseInt(this.rangeMax.value)>parseInt(event.target.value)){
      window.location.href = location.protocol + '//' + location.host + location.pathname+"?filter.v.price.gte="+event.target.value+"&filter.v.price.lte="+this.rangeMax.value;
    }
  }
  onRangeMax(event){
    if(parseInt(this.rangeMin.value)<parseInt(event.target.value)){
      window.location.href = location.protocol + '//' + location.host + location.pathname+"?filter.v.price.gte="+this.rangeMin.value+"&filter.v.price.lte="+event.target.value;
    }    
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  } 

}
 customElements.define("s-colemp",CollectionTemp,{extends:"div"});

class ProductTemp extends HTMLDivElement {
  constructor() {
    super();
      this.onCole = this.onColl();
  }
  onColl(){
    this.querySelector('.prd_description').innerHTML = this.querySelector('.prd_description').textContent;
  }

}
 customElements.define("s-product",ProductTemp,{extends:"div"});

class PredictiveSearch extends HTMLElement {
 constructor() {
  super();

  this.input = this.querySelector('input[type="search"]');
  this.predictiveSearchResults = this.querySelector('#predictive-search');

  this.input.addEventListener('input', this.debounce((event) => {
    this.onChange(event);
  }, 300).bind(this));
}

onChange() {
  const searchTerm = this.input.value.trim();

  if (!searchTerm.length) {
    this.close();
    return;
  }

  this.getSearchResults(searchTerm);
}

getSearchResults(searchTerm) {
  fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=4&section_id=predictive-search`)
  .then((response) => {
    if (!response.ok) {
      var error = new Error(response.status);
      this.close();
      throw error;
    }

    return response.text();
  })
  .then((text) => {
    const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.open();
  })
  .catch((error) => {
    this.close();
    throw error;
  });
}

open() {
  this.predictiveSearchResults.style.display = 'block';
}

close() {
  this.predictiveSearchResults.style.display = 'none';
}

debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
}
 customElements.define('predictive-search',PredictiveSearch);

// function addCustomElement(){
//   customElements.define("s-head",SiteHeader,{extends:"div"});
//   customElements.define("cart-temp",CartTemp,{extends:"div"});
//   customElements.define("s-colemp",CollectionTemp,{extends:"div"});
//   customElements.define("s-product",ProductTemp,{extends:"div"});
//   customElements.define('predictive-search',PredictiveSearch,{extends:"div"});
//  // alert("loaded");
// }

$(document).ready(function() {
  var sections = new theme.Sections();
  sections.register('collections-list-template', theme.FeaturedCollections);
  sections.register('collection-row-section', theme.CollectionRows);
  sections.register('collection-template', theme.Collection);
  sections.register('header-section', theme.HeaderSection);
  sections.register('list-collections-template', theme.ListCollections);
  sections.register('map-section', theme.Maps);
  sections.register('product-template', theme.Product);
  sections.register('slideshow-section', theme.SlideshowSection);
});
